import { faBoxesStacked } from "@fortawesome/pro-solid-svg-icons"
import { Box, Switch, TextField } from "@mui/material"
import { AppContext } from "components/AppContextProvider"
import { RouterPrompt } from "components/RouterPrompt"
import { Sidebar } from "components/sidedrawer/Sidebar2"
import { useFormikContext } from "formik"
import { useContext, useEffect, useRef, useState } from "react"
import { StyledBox, StyledListItem, StyledListItemText } from "shared/styled/General"
import * as Yup from "yup"

const IssueReportCategoryNameTextField = ({ t }) => {
  const { values, handleChange, handleBlur, touched, errors } = useFormikContext()
  return (
    <StyledListItem>
      <StyledBox>
        <StyledListItemText primary={t("global.name", "Name")} style={{ paddingBottom: "8px" }} />
      </StyledBox>
      <TextField
        autoComplete="off"
        fullWidth
        id="name"
        value={values.name}
        onChange={handleChange}
        onBlur={handleBlur}
        error={touched.name && errors.name ? true : false}
        helperText={touched.name && errors.name ? errors.name : null}
        variant="outlined"
        InputProps={{ disableUnderline: true }}
      />
    </StyledListItem>
  )
}

const IssueReportCategoryActiveSwitch = ({ t }) => {
  const { values, setFieldValue } = useFormikContext()
  return (
    <StyledListItem>
      <StyledBox>
        <StyledListItemText style={{ paddingBottom: "8px" }} primary={t("global.active", "Active")} />
      </StyledBox>

      <Switch
        onChange={(item) => {
          const checked = item.target.checked
          setFieldValue("isActive", checked)
        }}
        checked={values.isActive}
      />
    </StyledListItem>
  )
}

const validateionSchema = Yup.object().shape({
  name: Yup.string().required("Namn är obligatoriskt"),
  active: Yup.bool()
})

const IssueReportCategoryForm = (props) => {
  const { editItemResult, addResult, updateResult, editMode, onAddSubmit, onUpdateSubmit, t } = props
  const formRef = useRef()
  const appContext = useContext(AppContext)
  const initialValues =
    editMode && editItemResult.status === 2
      ? {
          ...editItemResult.data
        }
      : {
          id: 0,
          name: "",
          isActive: true
        }
  const [initialFormikValues, setInitialFormikValues] = useState(initialValues)

  const handleSubmit = (values) => {
    if (editMode) {
      onUpdateSubmit(values)
    } else {
      onAddSubmit(values)
    }
  }
  useEffect(() => {
    if (!appContext.isSidebarOpen) {
      formRef.current?.resetForm()
    }
  }, [appContext.isSidebarOpen])

  const buttonFeedbackResult = editMode ? updateResult : addResult

  return (
    <>
      <Sidebar
        validationSchema={validateionSchema}
        initialFormikValues={initialValues}
        handleSubmit={handleSubmit}
        setInitialFormikValues={setInitialFormikValues}
        formResult={buttonFeedbackResult}
        formRef={formRef}
        formData={{
          formId: "CustomFieldForm",
          titleEdit: t("global.edit_category", "Edit category"),
          titleNew: t("global.create_category", "Create category"),
          submitText: t("global.add_category", "Add category"),
          submitEditText: t("global.save_category", "Save category"),
          icon: faBoxesStacked
        }}>
        <RouterPrompt />
        <Box display="flex" flexDirection="column" gap={2}>
          <IssueReportCategoryNameTextField t={t} />
          <IssueReportCategoryActiveSwitch t={t} />
        </Box>
      </Sidebar>
    </>
  )
}
export default IssueReportCategoryForm
